var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"main-footer"},[_c('strong',[_vm._v(" Copyright © "+_vm._s(new Date().getFullYear())+" "),_c('a',{attrs:{"href":"javascript:void(0)"}},[_vm._v("CanPay")]),_vm._v(". ")]),_vm._v(" All rights reserved. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }